import Vue from 'vue'
import Vuex from 'vuex'

import userinfo from './modules/userinfo'
// 永続化なし

Vue.use(Vuex)

const store = new Vuex.Store({
  modules: {
    userinfo,
  }
})

export default store
